import React from 'react'
import {
    Edit,
    SimpleForm,
    TextInput,
    DateInput,
    NumberInput,
} from 'react-admin'


export const DecretoEdit = props => (
    <Edit {...props}>
        <SimpleForm>
            <NumberInput source="id" disabled={true}/>
            <TextInput source="name" />
            <TextInput source="description" />
            <DateInput source="date" />
        </SimpleForm>
    </Edit>
);
